module.exports = __webpack_public_path__ + "static/script_p2-02a95d15becc40e57bd3112bd24f710d.png";